import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import Service from './services/general';

Vue.use(Vuex);
mapboxgl.accessToken = Service.getTokenMap();

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
  },
  mutations: {
    authSuccess(state, token) {
      state.token = token;
      state.status = 'success';
    },
    authError(state) {
      state.token = '';
      state.status = 'error';
    },
    authLogout(state) {
      state.token = '';
      state.status = '';
    },
  },
  actions: {
    login({ commit }, ldata) {
      console.log('FRONT_AUTH-->', ldata)
      return new Promise((resolve, reject) => {
        axios.post(Service.getServe()+ 'api/auth', ldata)
          .then(async (response) => {
            let token = response.data.token;
            localStorage.setItem('token', token);
            if (response.data.rol_lugar.length == 0) {
              commit('authError', 'Error en autenticación');
              reject({status: 'error', msg: 'Usuario sin rol o función', roles: 0});
            } else if(response.data.rol_lugar.length == 1) {
              localStorage.setItem('params', Service.strencdes(JSON.stringify({
                userId: response.data.usuario_id,
                roluser: response.data.rol_lugar[0].rol_tipo.id,
                roluserlugarid: response.data.rol_lugar[0].lugar_tipo.id,
                pathSystem: 'SieCctpBundle',
                ie_id: response.data.codigo_sie
              }), 12));
              if(response.data.rol_lugar[0].rol_tipo.id==9) {
                if (!response.data.rol_lugar[0].sub_sistema.includes('CCTP')) {
                  commit('authError', 'Error en autenticación');
                  reject({status: 'error', msg: 'No tiene acceso al Sistema CCTP', roles: 0});
                }
              }
              await Service.setUsuario(JSON.stringify({name: response.data.nombre, rol: response.data.rol_lugar[0].rol_tipo.rol}));
              await Service.setMenus(response.data.rol_lugar[0].rol_tipo.id);
              commit('authSuccess', token);
              resolve({status: 'success', msg: '', roles: 1, cambio_clave: response.data.cambio_clave});
            } else {
              localStorage.setItem('params', Service.strencdes(JSON.stringify({
                userId: response.data.usuario_id,
                nombre: response.data.nombre,
                roluser: response.data.rol_lugar,
                pathSystem: 'SieCctpBundle',
                ie_id: response.data.codigo_sie
              }), 12));
              commit('authSuccess', token);
              resolve({status: 'success', msg: '', roles: 2, cambio_clave: response.data.cambio_clave, rol_lugar: response.data.rol_lugar});
            }
            // axios.defaults.headers.common['Authorization'] = "Bearer " + token;
          })
          .catch((error) => {
            localStorage.removeItem('token');
            commit('authError', 'Error en autenticación');
            reject({status: 'error', msg: error + 'Usuario o Contraseña incorrecto'});
          });
          /* let token = 'gdhaskdamdag';
          localStorage.setItem('token', token);
          localStorage.setItem('params', Service.strencdes(JSON.stringify({
            userId: 423422,
            roluser: 10,
            roluserlugarid: 31456,
            pathSystem: 'SieCctpBundle',
            ie_id: 123134
          }), 12));
          commit('authSuccess', token);
          resolve({status: 'success', msg: ''}); */
      });
    },
    logout({ commit }) {
      // eslint-disable-next-line
      return new Promise((resolve, reject)=>{
        commit('authLogout');
        localStorage.removeItem('token');
        localStorage.removeItem('params');
        localStorage.removeItem('usr');
        localStorage.removeItem('menu');
        localStorage.removeItem('itr');
        localStorage.removeItem('ift');
        // delete axios.defaults.headers.common['Authorization'];
        resolve();
      })
    },
    changel({ commit }, cdata) {      
      return new Promise((resolve, reject) => {
        cdata.id = Service.getParams().userId;
        axios.post(Service.getServe()+ 'api/change/auth', cdata)
          .then((response) => {
            if (response.data.estado == 200) {
              resolve({status: 'success', msg: response.data.message});
            } else {
              reject({status: 'error', msg: response.data.message});
            }
          })
          .catch(() => {
            reject({status: 'error', msg: ''. commit[0]});
          });
      });
    },
  },
  getters: {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
  }
});
